import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ce60962"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "guardian-columns-select-container opened",
  "data-testid": "columns-select-pane"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "header-text" }, "Columns", -1))
const _hoisted_4 = { class: "main" }
const _hoisted_5 = {
  key: 1,
  class: "guardian-columns-select-container closed",
  "data-testid": "columns-select-pane"
}
const _hoisted_6 = { class: "header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CollapseButtonLR = _resolveComponent("CollapseButtonLR")!
  const _component_UserColumnsSelectSection = _resolveComponent("UserColumnsSelectSection")!

  return (_ctx.open)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_CollapseButtonLR, {
            class: "collapse-button",
            color: "dark-gray",
            size: 20,
            open: _ctx.open,
            "on-click": _ctx.onClickCollapseButton
          }, null, 8, ["open", "on-click"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_UserColumnsSelectSection, {
            "section-title": _ctx.profileSectionTitle,
            "column-defs": _ctx.profileColumnDefs,
            "column-visibility": _ctx.columnVisibility.profileColumnVisibility,
            "on-toggle": _ctx.onChangeColumnVisibility
          }, null, 8, ["section-title", "column-defs", "column-visibility", "on-toggle"]),
          _createVNode(_component_UserColumnsSelectSection, {
            "section-title": _ctx.notesSectionTitle,
            "column-defs": _ctx.notesColumnDefs,
            "column-visibility": _ctx.columnVisibility.notesColumnVisibility,
            "on-toggle": _ctx.onChangeColumnVisibility
          }, null, 8, ["section-title", "column-defs", "column-visibility", "on-toggle"])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_CollapseButtonLR, {
            class: "collapse-button",
            color: "dark-gray",
            size: 20,
            open: _ctx.open,
            "on-click": _ctx.onClickCollapseButton
          }, null, 8, ["open", "on-click"])
        ])
      ]))
}